import * as React from "react";
import { Button, Dialog, Icon } from "@app/components";
import { SuccessContainer, ProfileSuccessText } from "../profileEditSuccess/success-components";
import { SuccessText } from "@app/modules/signUp/sign-up.component";

type Props = { onClose: (e: any) => void; message: string ;subtitle?:string;buttonMessage?:string};

export default function AuthFail({ onClose, message,subtitle = '', buttonMessage = "Okay!" }: Props) {
  return (
    <Dialog noTitle={true} onClose={onClose}>
      <SuccessContainer>
        <Icon name="failIcon" />
        <ProfileSuccessText className="failure">{message}</ProfileSuccessText>
        {subtitle &&
        <SuccessText>
           {subtitle}
          </SuccessText>
        }
        {buttonMessage &&
        <Button
          variant="newsecondary"
          type="button"
          onClick={onClose}
        >
          {buttonMessage}
          </Button>
}
      </SuccessContainer>
    </Dialog>
  );
}